import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VocabularyService {
   vocabulariesSubject = new BehaviorSubject<any[]>([]);
  
  vocabularies$ = this.vocabulariesSubject.asObservable();

  emit(vocabularies: any[]): void {
    this.vocabulariesSubject.next(vocabularies);
  }

  clear(): void {
    this.vocabulariesSubject.next([])
  }
}
